module.exports = new __parcel__URL__("cornershop-shopper-ios.d8300df0.png").toString();